/* eslint-disable no-console */
type Params = {
  src?: string;
  content?: string;
  id?: string;
  testID?: string;
  target?: "head" | "body";
};

export function injectScript({
  src,
  id,
  testID,
  target = "head",
  content
}: Params): Promise<boolean> {
  return new Promise((resolve, reject) => {
    if (typeof document === "undefined") {
      reject(new Error("document is undefined"));
      return;
    }

    // check if already defined
    if (id && document.getElementById(id)) {
      resolve(true);
      console.log(`Script already loaded: ${id}`);
      return;
    }

    const scriptTag = document.createElement("script");
    scriptTag.type = "text/javascript";
    if (id) {
      scriptTag.id = id;
    }
    if (testID) {
      scriptTag.setAttribute("data-testid", testID);
    }
    if (src) {
      scriptTag.src = src;
      scriptTag.async = true;
      scriptTag.onerror = (err) => {
        console.error(`Script ${id} failed to load: ${err}`);
        reject(err);
      };
      scriptTag.onload = () => {
        console.log(`Script ${id} successfully loaded`);
        resolve(true);
      };
    }

    if (content) {
      scriptTag.innerHTML = content;
      console.log(`Script ${id} content successfully loaded`);
      resolve(true);
    }

    if (target === "head") {
      const tags = document.getElementsByTagName("script");
      if (!!tags.length && tags[0].parentElement) {
        tags[0].parentElement.insertBefore(scriptTag, tags[0]);
      }
    } else {
      document.body.appendChild(scriptTag);
    }
    resolve(true);
  });
}
